import '../../stylesheets/News.css';
import { selectAllStrings } from '../language/languageSlice';
import { useSelector } from 'react-redux';
import { constants } from '../../constants';



const PostExcerpt = ({post}) => {
    const strings = useSelector(selectAllStrings);
    return (<section className="post">
        <span className="title">{post.titolo}</span>
        <span className="text">{post.testo}</span>
        <a className="read-more" href={post.link} target="_blank">{strings.read_more}</a>
    </section>);
};



const NewsList = ({news, status, error, layout}) => {
    return (<div className="news-list">
    {status === 'loading' ? <div className="loader"></div> : status === 'succeeded' ? news.map((post) => (<PostExcerpt post={post} key={post.idPush}/>)) : 
            status === 'error' ? <div>{error}</div> : null}
            </div>);
};

export default NewsList;